import { useQuery } from '@tanstack/react-query';
import { getDiaryData } from '../../../api/diary-service';

const useDiaryData = (currentDay) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['diary', currentDay],
        queryFn: () => getDiaryData(currentDay),
        enabled: !!currentDay,
        staleTime: 1000 * 60 * 5,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return { data, isLoading, isError, error };
};

export default useDiaryData;
